export default (api) => {
    return {
        index: options => api.get('settings', options),
        get: (key, options) => api.get(`settings/${key}`, options),
        show: (key, options) => api.get(`settings/${key}`, options),//Legacy
    }
}
